import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import { Button, FocusRingVariants, minWidth } from '@calm-web/design-system';

import facebookIcon from 'icons/facebook-f.svg';

export const Wrapper = styled(Button).attrs({
	focusRingVariant: FocusRingVariants.Dark,
})<{ $noPadding: boolean }>`
	align-items: center;
	display: flex;
	height: 48px;
	margin-bottom: 12px;
	width: 100%;
	${p =>
		p.$noPadding &&
		css`
			padding: 0;
		`}

	${minWidth('tablet')} {
		height: 56px;
	}
`;

export const FBIcon = styled(facebookIcon)<{ $noMargin: boolean; $iconColor: string }>`
	height: 24px;
	width: 24px;
	margin-right: ${p => (p.$noMargin ? '0' : '14px')};

	path {
		fill: ${p => palette(p.$iconColor)};
	}

	${minWidth('tablet')} {
		width: 30px;
		height: 30px;
	}
`;
